import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../../lib/api-client";
import { queryKeys } from "../query-keys";
import {
  CampaignListResponseSchema,
  CampaignSchema,
} from "@applicant-reviewer/api";

export function useCampaigns() {
  return useQuery({
    queryKey: queryKeys.campaigns.list(),
    queryFn: async () => {
      const res = await apiClient.get("/campaigns", CampaignListResponseSchema);
      return res.campaigns;
    },
  });
}

export function useCampaign(id: string) {
  return useQuery({
    queryKey: queryKeys.campaigns.detail(id),
    queryFn: () => apiClient.get(`/campaigns/${id}`, CampaignSchema),
    enabled: Boolean(id),
  });
}
